import "./style.scss";
import { FC, memo } from "react";
import { Divider, Skeleton } from "antd";
import { StyledCollapseContainer, StyledCollapseAdd } from "./index.styled";
import CollapseItems from "./collapse-component";
import { useQuery } from "@tanstack/react-query";
import { FormattedMessage, useIntl } from "react-intl";
import { getAllTelegramBotDialogue } from "@lib/api/telegramBotDialogue";
import { useDisclosure } from "@lib/hooks/useDisclosure";
import PageHeader from "@lib/components/MiniComponents/Others/PageHeader";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import CollapseItemForm from "./collapse-item-form";
import { useParams } from "react-router-dom";

type Props = {
  botConfigName: string;
  requireAuth: boolean;
};

const TelegramBotDialogue: FC<Props> = ({ botConfigName, requireAuth }) => {
  const { configId } = useParams();
  const { messages } = useIntl();
  const { isOpen: isAddNewDialogueOpen, toggle: toggleAddNewDialogue } =
    useDisclosure();

  const {
    data: dialogueData,
    isLoading: isDialogueLoading,
    refetch: refetchDialogues,
  } = useQuery({
    queryKey: ["telegram-bot-auth-dialogue", { configId, requireAuth }],
    enabled: !!configId,
    queryFn: () =>
      getAllTelegramBotDialogue({
        requireAuth,
        configId,
      }),
  });

  const handleRefetchDialogues = () => {
    refetchDialogues();
  };

  return (
    <StyledCollapseContainer className="Collapse-Container">
      <StyledFlex
        style={{ marginBottom: "5px", justifyContent: "space-between" }}
      >
        <PageHeader
          text={
            <FormattedMessage
              id="TELEGRAM.TELEGRAM_BOT_DIALOGUES"
              values={{
                name: botConfigName,
              }}
            />
          }
        />

        <StyledFlex style={{ gap: 10 }}>
          <ActionButton
            onClick={handleRefetchDialogues}
            type="refresh"
            noLabel
          />

          <ActionButton
            onClick={toggleAddNewDialogue}
            label={messages["TELEGRAM.ADD_NEW_DIALOGUE"] as string}
            type="add"
          />
        </StyledFlex>
      </StyledFlex>

      <Divider style={{ margin: "0" }} />

      {isDialogueLoading ? (
        <Skeleton />
      ) : (
        <CollapseItems
          data={dialogueData?.data}
          refetchDialogue={handleRefetchDialogues}
          requireAuth={requireAuth}
        />
      )}

      {isAddNewDialogueOpen && (
        <StyledCollapseAdd className="Collapse-Add">
          <CollapseItemForm
            mode="add"
            requireAuth={requireAuth}
            refetchDialogue={handleRefetchDialogues}
            closeModal={(event?) => {
              if (event) event.stopPropagation();
              toggleAddNewDialogue();
            }}
          />
        </StyledCollapseAdd>
      )}
    </StyledCollapseContainer>
  );
};

export default memo(TelegramBotDialogue);
